export const getLabel = ({
	city,
	longState,
	searchValue,
	state,
}: {
	city: string | null;
	state: string;
	longState: string;
	searchValue: string;
}) => {
	if (city) return `${city}, ${longState} (${state})`;
	return `${longState} (${state})`;
};
